/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ delta: NonNullable<unknown> }} Coinvestments_Performancereport_Sinceclose3Inputs */

const en_coinvestments_performancereport_sinceclose3 = /** @type {(inputs: Coinvestments_Performancereport_Sinceclose3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.delta} since close`)
};

/**
* | output |
* | --- |
* | "{delta} since close" |
*
* @param {Coinvestments_Performancereport_Sinceclose3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_performancereport_sinceclose3 = /** @type {((inputs: Coinvestments_Performancereport_Sinceclose3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Performancereport_Sinceclose3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_performancereport_sinceclose3(inputs)
});
export { coinvestments_performancereport_sinceclose3 as "coInvestments_performanceReport_sinceClose" }